import { useEffect, useMemo } from 'react';

// Optimizuota versija su papildomais komentarais ir geresne veikimo logika
export const useTendencijosFilters = (originalData, filtersMain, filters) => {
    // Optimizacija: naudojame useMemo vietoj state, kad išvengtume bereikalingų perskaičiavimų
    const { tvarkyta, isfiltruotiTipai } = useMemo(() => {
        // Apsaugos patikrinimas
        if (!originalData?.atsakymai || !originalData?.tipai) {
            return { tvarkyta: [], isfiltruotiTipai: [] };
        }

        try {
            // ===== LOKALINIS FILTRAVIMAS =====
            // Visos filtravimo operacijos atliekamos kliento pusėje, nes jau turime visus duomenis
            
            // 1. Filtruojame formų tipus pagal kasPildo - pagrindinė filtravimo sąlyga
            const filteredTypes = originalData.tipai.filter(type => {
                if (!type?.attributes?.kasPildo) return false;
                return type.attributes.kasPildo === filtersMain.kasPildo;
            });

            // 2. Filtruojame visus atsakymus pagal kasPildo
            let filteredAnswers = originalData.atsakymai.filter(answer => {
                if (!answer?.attributes?.kasPildo) return false;
                return answer.attributes.kasPildo === filtersMain.kasPildo;
            });

            // 3. Filtruojame pagal imonesPavadinimas, jei yra nustatyta
            if (filtersMain.imonesPavadinimas) {
                filteredAnswers = filteredAnswers.filter(answer => {
                    if (!answer?.attributes?.imonesPavadinimas) return false;
                    return answer.attributes.imonesPavadinimas === filtersMain.imonesPavadinimas;
                });
            } else {
            }

            // 4. Papildomi filtrai iš URL parametrų
            if (filters && Object.keys(filters).length > 0) {
                Object.entries(filters).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && key !== 'kasPildo' && key !== 'imonesPavadinimas') {
                        // Filtruojame pagal papildomus parametrus tik jei jie dar nenaudoti
                        filteredAnswers = filteredAnswers.filter(answer => {
                            const attrValue = answer?.attributes?.[key];
                            if (attrValue === undefined || attrValue === null) return false;
                            
                            // Jei reikšmė yra masyvas, tikriname ar yra value reikšmėje
                            if (Array.isArray(attrValue)) {
                                return attrValue.includes(value);
                            }
                            
                            // Jei reikšmė yra objektas, tikriname ar yra value rakto reikšmėje
                            if (typeof attrValue === 'object' && attrValue !== null) {
                                return Object.values(attrValue).includes(value);
                            }
                            
                            // Kitais atvejais tiesiog lyginame reikšmes
                            return attrValue === value;
                        });
                    }
                });
            }

            return {
                tvarkyta: filteredAnswers,
                isfiltruotiTipai: filteredTypes
            };
        } catch (error) {
            return { tvarkyta: [], isfiltruotiTipai: [] };
        }
    }, [originalData, filtersMain, filters]); // Perskaičiuojame tik kai keičiasi šie duomenys

    // Logginam filtravavimo rezultatus papildomai
    useEffect(() => {
    }, [tvarkyta, isfiltruotiTipai, filtersMain]);

    return {
        tvarkyta,
        isfiltruotiTipai
    };
};

export default useTendencijosFilters;
